var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var unpackServerLogin = function (response) {
    return {
        accessToken: response.access_token,
    };
};
export var unpackServerCurrent = function (response) {
    return {
        applicationRights: response.application_rights,
        fullName: response.full_name,
        userName: response.user_name,
        organizations: response.organizations,
    };
};
export var unpackSignUp = function (response) { return ({
    accessToken: response.access_token,
    clientId: response.client_id,
    expiresIn: response.expires_in,
    paymentIntentToken: response.token,
    partnerId: response.partner_id,
    userId: response.user_id,
}); };
export var packPartnerSelfOnboarding = function (payload) {
    return __assign({ name: payload.companyName, user: {
            name: payload.userName,
        }, country: payload.billingCountry, grecaptcha_token: payload.grecaptchaToken, submission_id: payload.submissionId }, (payload.utm ? { utm: payload.utm } : {}));
};
export var packSignupPayload = function (payload) {
    return {
        company_name: payload.companyName,
        user_name: payload.userName,
        billing_country: payload.billingCountry,
        partner_payload: payload.partnerPayload,
        client_id: payload.clientId,
        grecaptcha_token: payload.grecaptchaToken,
        tax_id: payload.taxId,
        tax_id_type: payload.taxIdType,
        coupon: payload.coupon,
        submissionId: payload.submissionId,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aC5tYXBwZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhdXRoLm1hcHBlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQVlBLE1BQU0sQ0FBQyxJQUFNLGlCQUFpQixHQUFHLFVBQy9CLFFBQWlDO0lBRWpDLE9BQU87UUFDTCxXQUFXLEVBQUUsUUFBUSxDQUFDLFlBQVk7S0FDbkMsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLG1CQUFtQixHQUFHLFVBQ2pDLFFBQW1DO0lBRW5DLE9BQU87UUFDTCxpQkFBaUIsRUFBRSxRQUFRLENBQUMsa0JBQWtCO1FBQzlDLFFBQVEsRUFBRSxRQUFRLENBQUMsU0FBUztRQUM1QixRQUFRLEVBQUUsUUFBUSxDQUFDLFNBQVM7UUFDNUIsYUFBYSxFQUFFLFFBQVEsQ0FBQyxhQUFhO0tBQ3RDLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxZQUFZLEdBQUcsVUFDMUIsUUFBOEIsSUFDVCxPQUFBLENBQUM7SUFDdEIsV0FBVyxFQUFFLFFBQVEsQ0FBQyxZQUFZO0lBQ2xDLFFBQVEsRUFBRSxRQUFRLENBQUMsU0FBUztJQUM1QixTQUFTLEVBQUUsUUFBUSxDQUFDLFVBQVU7SUFDOUIsa0JBQWtCLEVBQUUsUUFBUSxDQUFDLEtBQUs7SUFDbEMsU0FBUyxFQUFFLFFBQVEsQ0FBQyxVQUFVO0lBQzlCLE1BQU0sRUFBRSxRQUFRLENBQUMsT0FBTztDQUN6QixDQUFDLEVBUHFCLENBT3JCLENBQUM7QUFFSCxNQUFNLENBQUMsSUFBTSx5QkFBeUIsR0FBRyxVQUN2QyxPQUF5QjtJQUV6QixrQkFDRSxJQUFJLEVBQUUsT0FBTyxDQUFDLFdBQVcsRUFDekIsSUFBSSxFQUFFO1lBQ0osSUFBSSxFQUFFLE9BQU8sQ0FBQyxRQUFRO1NBQ3ZCLEVBQ0QsT0FBTyxFQUFFLE9BQU8sQ0FBQyxjQUFjLEVBQy9CLGdCQUFnQixFQUFFLE9BQU8sQ0FBQyxlQUFlLEVBQ3pDLGFBQWEsRUFBRSxPQUFPLENBQUMsWUFBWSxJQUNoQyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsR0FBRyxFQUFFLE9BQU8sQ0FBQyxHQUFHLEVBQUUsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLEVBQzVDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQUcsVUFDL0IsT0FBeUI7SUFFekIsT0FBTztRQUNMLFlBQVksRUFBRSxPQUFPLENBQUMsV0FBVztRQUNqQyxTQUFTLEVBQUUsT0FBTyxDQUFDLFFBQVE7UUFDM0IsZUFBZSxFQUFFLE9BQU8sQ0FBQyxjQUFjO1FBQ3ZDLGVBQWUsRUFBRSxPQUFPLENBQUMsY0FBYztRQUN2QyxTQUFTLEVBQUUsT0FBTyxDQUFDLFFBQVE7UUFDM0IsZ0JBQWdCLEVBQUUsT0FBTyxDQUFDLGVBQWU7UUFDekMsTUFBTSxFQUFFLE9BQU8sQ0FBQyxLQUFLO1FBQ3JCLFdBQVcsRUFBRSxPQUFPLENBQUMsU0FBUztRQUM5QixNQUFNLEVBQUUsT0FBTyxDQUFDLE1BQU07UUFDdEIsWUFBWSxFQUFFLE9BQU8sQ0FBQyxZQUFZO0tBQ25DLENBQUM7QUFDSixDQUFDLENBQUMifQ==